/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2023 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import {Module, Mutation, VuexModule} from "vuex-module-decorators";

const {
    VUE_APP_THEME_COLOR,
} = process.env

@Module({
    name: 'AppStore',
    namespaced: true,
})
export default class AppStore extends VuexModule {
    appLanguage: string | null = null
    backgroundOperations = false
    disableScroll = false
    fullscreen = false
    overlayUi = false
    synching = false
    themeColor = VUE_APP_THEME_COLOR
    toolbarTitle: string | null = null
    transition = 'dialog-transition'

    @Mutation
    setAppLanguage(language: string | null): void {
        this.appLanguage = language
    }

    @Mutation
    setBackgroundOperations(status: boolean): void {
        this.backgroundOperations = status
    }

    @Mutation
    setDisableScroll(status: boolean): void {
        this.disableScroll = status
    }

    @Mutation
    setFullscreen(status: boolean): void {
        this.fullscreen = status
    }

    @Mutation
    setOverlayUi(status: boolean): void {
        this.overlayUi = status
    }

    @Mutation
    setSynching(status: boolean): void {
        this.synching = status
    }

    @Mutation
    setThemeColor(themeColor: string | null): void {
        this.themeColor = themeColor || VUE_APP_THEME_COLOR
    }

    @Mutation
    setToolbarTitle(title: string | null): void {
        this.toolbarTitle = title
    }

    @Mutation
    setTransition(transition = 'dialog-transition'): void {
        this.transition = transition
    }
}
